export default __webpack_public_path__ + "static/media/project4.8e4fdc95.png";